import React from 'react'
import Link from 'gatsby-link'
import { MainWrapper, Title } from '../components/Headings';

const AboutPage = () =>
  <MainWrapper>
    <Title>About</Title>
    <div>
      <p>
        I'm Kyle Kurtz.
      </p>
      <p>
        I'm a Senior Software Engineer for Target in Minneapolis, MN.
      </p>
      <p>
        Please contact me if you would like to work on a project together, or just want to chat.
      </p>
    </div>
  </MainWrapper>


export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/about.jsx